import React, { Component } from "react";
import { Link } from "react-router-dom";
import buroRingLogo from 'assets/funnel/buro_ring.png';

class JobImpressum extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Impressum | Büroring Personalmanagement";
  }

  renderLogoHeader() {
    return (
      <div className="text-center py-3 border-bottom">
        <img src={buroRingLogo} alt="Büroring Personalmanagement" style={{ height: 60, objectFit: 'contain' }} />
      </div>
    );
  }

  renderFooter() {
    return (
      <div className="mt-auto border-top px-4 py-4 text-center text-muted small">
        <div className="fw-semibold text-dark">Powered by Ali_Christoph</div>
        <div className="text-muted mb-3">Ein Projekt von Ali_Christoph</div>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <Link target="_blank" rel="noopener noreferrer" to="/job/impressum" className="text-dark text-decoration-underline small">Impressum</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/agb" className="text-dark text-decoration-underline small">AGB</Link>
        </div>
        <div className="mt-2">
          <Link target="_blank" rel="noopener noreferrer" to="/job/datenschutz" className="text-dark text-decoration-underline small">Datenschutzerklärung</Link>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="d-flex flex-column min-vh-100 bg-white" style={{ maxWidth: 480, margin: '0 auto' }}>
        {this.renderLogoHeader()}

        <div className="px-4 py-4 flex-grow-1">
          <h2 className="fw-bold mb-4">Impressum</h2>

          {/* Company Info */}
          <section className="mb-4">
            <h5 className="fw-bold">Ali_Christoph</h5>
            <p className="mb-1">[Straße und Hausnummer]</p>
            <p className="mb-1">[PLZ] [Stadt], [Land]</p>
          </section>

          {/* Contact */}
          <section className="mb-4">
            <h5 className="fw-bold">Kontakt</h5>
            <p className="mb-1">Telefon: [+XX XXX XXXXXXX]</p>
            <p className="mb-1">E-Mail: [office@example.com]</p>
          </section>

          {/* Legal */}
          <section className="mb-4">
            <h5 className="fw-bold">Rechtliche Angaben</h5>
            <p className="mb-1">UID-Nr.: [ATU XXXXXXXX]</p>
            <p className="mb-1">Firmenbuchnummer: [FN XXXXXXX]</p>
            <p className="mb-1">Firmenbuchgericht: [Handelsgericht Wien]</p>
            <p className="mb-1">Dienstleistungen: Handel und IT Dienstleistungen, Projektplanung und Projektrealisierung</p>
          </section>

          {/* Management */}
          <section className="mb-4">
            <h5 className="fw-bold">Geschäftsführung</h5>
            <p className="mb-0">[Name(n) der Geschäftsführer]</p>
          </section>

          {/* Authority */}
          <section className="mb-4">
            <h5 className="fw-bold">Aufsichtsbehörde</h5>
            <p className="mb-0">Mitglied der WKÖ und der Wirtschaftskammer [Stadt] ([Bereich])</p>
          </section>

          {/* Liability */}
          <section className="mb-4">
            <h5 className="fw-bold">Haftungsausschluss</h5>
            <p className="text-muted small">
              Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
              Als Diensteanbieter sind wir gemäß gesetzlichen Vorschriften für eigene Inhalte auf diesen
              Seiten verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte
              fremde Informationen zu überwachen.
            </p>
          </section>

          {/* Links */}
          <section className="mb-4">
            <h5 className="fw-bold">Haftung für Links</h5>
            <p className="text-muted small">
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
              Seiten verantwortlich.
            </p>
          </section>

          {/* Copyright */}
          <section className="mb-4">
            <h5 className="fw-bold">Urheberrecht</h5>
            <p className="text-muted small">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
              dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede
              Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

          {/* EU Dispute */}
          <section className="mb-4">
            <h5 className="fw-bold">Online-Streitbeilegung</h5>
            <p className="text-muted small">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit.
              Verbraucher haben die Möglichkeit, Beschwerden auf der Plattform der EU-Kommission
              einzureichen. Wir sind bereit, an außergerichtlichen Einigungsverfahren teilzunehmen.
            </p>
          </section>
        </div>

        {this.renderFooter()}
      </div>
    );
  }
}

export default JobImpressum;
